import { FilterValue } from '@/models/filter/FilterType';

export const isNonEmptyStringArray = (value: FilterValue): value is string[] =>
  Array.isArray(value) &&
  value.length > 0 &&
  value.every((filterValue): filterValue is string => typeof filterValue === 'string');
